import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileService } from '@shared/services/api/profile.service';
import { Roles } from '@shared/models/types';
import { NGXLogger } from 'ngx-logger';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';

export const termsAndConditionsGuard: CanActivateFn = (): Observable<boolean> => {
  const profileService = inject(ProfileService);
  const logger = inject(NGXLogger);
  const router = inject(Router);

  return profileService.role$.pipe(
    switchMap((role) => {
      if (role === Roles.ADMIN) {
        return of(true);
      }
      return profileService.acceptedTerms$.pipe(
        switchMap((hasAcceptedTerms) => {
          if (!hasAcceptedTerms) {
            return throwError(() => new Error('User has not accepted terms and conditions yet.'));
          }
          return of(true);
        })
      );
    }),
    catchError((error) => {
      logger.info('[TermsAndConditions guard] checking user:', error);
      router.navigate(['/terms-and-conditions']);
      return of(false);
    })
  );
};
